<template>
  <div class="flex-grow-1 min-h-0 d-flex flex-column overflow-y-auto">
    <div class="row g-3 mx-0 flex-grow-1 min-h-0 align-items-start w-100 min-w-0">
      <div class="col-12 col-xl-4 ps-md-0">
        <h6 class="mb-4 text-gray-700">Участники</h6>
        <participants-sidebar
          :insurer="policy.insurer"
          :insureds="policy.insureds"
          :vehicles="policy.vehicle"
          :mode="mode"
          :module="module"
        />
      </div>
      <div class="col-12 col-xl-8 min-w-0 pe-md-0">
        <h6 class="mb-4 text-gray-700">Договор</h6>
        <policy-bpm-card>
          <template v-slot:fields>
            <div class="col-md-6 col-xl-4">
              <date-field
                :model-value="policy.treaty.date"
                :required="true"
                :mb="5"
                :min="treatyMinDate"
                :disabled="changeDisabled"
                placeholder="Дата начала договора"
                name="treaty_date"
                id="treaty.date"
                @update:model-value="$emit('update:treaty-date', $event)"
              />
            </div>
            <div class="col-md-6 col-xl-4">
              <date-field
                :model-value="policy.treaty.term"
                :required="true"
                :mb="5"
                :min="treatyMinEndDate"
                :max="treatyMaxEndDate"
                :disabled="changeDisabled"
                placeholder="Дата окончания"
                name="treaty_term"
                id="treaty.term"
                @update:model-value="$emit('update:treaty-term', $event)"
              />
            </div>
            <div class="col-md-6 col-xl-4">
              <div class="custom-select dynamic">
                <label for="properties.duration">Срок</label>
                <v-select
                  :model-value="duration"
                  input-id="properties.duration"
                  :options="dictionaries.durations"
                  :disabled="changeDisabled"
                  :reduce="item => item.id"
                  placeholder="Выберите..."
                  class="mb-3 bg-gray-100 form rounded"
                  label="title"
                  @update:model-value="$emit('update:duration', $event)"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="custom-select dynamic">
                <label for="policy.manager" class="required">Менеджер</label>
                <v-select
                  :loading="dictionaries.loading.managers"
                  :model-value="policy.manager"
                  input-id="policy.manager"
                  :options="dictionaries.managers"
                  :disabled="dictionaries.loading.managers || dictionaries.disabled.manager || changeDisabled"
                  :reduce="item => item.id"
                  :required="true"
                  placeholder="Выберите..."
                  class="mb-3 bg-gray-100 form rounded"
                  label="name"
                  @update:model-value="$emit('update:manager', $event)"
                />
              </div>
            </div>
          </template>
          <template v-slot:additionalPanel>
            <template v-if="!dgpoForbidden">
              <div v-if="!policy.dgpo && !dgpoRequired" class="empty-card" @click="$emit('add-dgpo')">
                <span class="fs-7 text-primary">Добавить ДГПО ВТС +</span>
              </div>
              <dgpo-bpm-card
                v-if="policy.dgpo"
                :dgpo="policy.dgpo"
                :mode="mode"
                :module="module"
                :agentsDictionary="dictionaries.agents"
                :removable="!dgpoRequired"
                @update:dgpo="onDgpoUpdate"
              />
            </template>
          </template>
        </policy-bpm-card>
      </div>
    </div>
  </div>
</template>

<script>
import ParticipantsSidebar from '@/components/Form/Bpm/Participants/ParticipantsSidebar.vue'
import PolicyBpmCard from '@/components/Form/Bpm/Policy/PolicyBpmCard.vue'
import DgpoBpmCard from '@/components/Form/Bpm/Policy/DgpoBpmCard.vue'
import DateField from '@/components/Fields/DateField'
import vSelect from 'vue-select'

export default {
  name: 'BpmOgpoTreatyStep',
  components: {
    ParticipantsSidebar,
    PolicyBpmCard,
    DgpoBpmCard,
    DateField,
    vSelect,
  },
  props: {
    policy: {
      type: Object,
      required: true,
    },
    mode: {
      type: [Object, Function],
      required: true,
    },
    module: {
      type: Function,
      required: true,
    },
    changeDisabled: {
      type: Boolean,
      default: false,
    },
    dictionaries: {
      type: Object,
      required: true,
    },
    duration: {
      type: Object,
      required: true,
    },
    treatyMinDate: {
      type: String,
      default: '',
    },
    treatyMinEndDate: {
      type: String,
      default: '',
    },
    treatyMaxEndDate: {
      type: String,
      default: '',
    },
  },
  emits: [
    'add-dgpo',
    'update:dgpo',
    'update:treaty-date',
    'update:treaty-term',
    'update:duration',
    'update:manager',
  ],
  computed: {
    dgpoForbidden() {
      return this.module.Wizard.isDgpoForbidden(this.policy)
    },
    dgpoRequired() {
      return Boolean(this.policy.scoring?.dgpo_required) && !this.dgpoForbidden
    },
  },
  watch: {
    dgpoRequired: {
      immediate: true,
      handler(required) {
        if (required && !this.policy.dgpo) {
          this.$emit('add-dgpo')
        }
      },
    },
    dgpoForbidden: {
      immediate: true,
      handler(forbidden) {
        if (forbidden && this.policy.dgpo) {
          this.$emit('update:dgpo', null)
        }
      },
    },
  },
  methods: {
    onDgpoUpdate(value) {
      if (value === null && this.dgpoRequired) {
        return
      }
      this.$emit('update:dgpo', value)
    },
  },
}
</script>
